module.exports = __webpack_public_path__ + "static/media/Startseite.8681eaac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Startseite.jpg
// module id = 393
// module chunks = 0